import React, {Component} from 'react'
//STYLE
import './SideBar.css'
//OWN COMPONENTS
import NavigationComponent from './NavigationComponent'
import {Logo} from '../../Map/Common/Logo'
import LogoSVG from '../../../images/bettair_logo_white.png'
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import IconMenu from 'react-toolbox/lib/menu/IconMenu';
import MenuItem from 'react-toolbox/lib/menu/MenuItem';
import MenuDivider from 'react-toolbox/lib/menu/MenuDivider';
import Button from "react-toolbox/lib/button/Button"
import Drawer from 'react-toolbox/lib/drawer/Drawer';

import MobileDetect from 'mobile-detect';


/*** REDUX  ****/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
/*** REDUX ACTIONS ***/
import * as organizationsActions from '../../../actions/organizations';

import {withRouter, Link} from "react-router-dom";
import * as UserActions from "../../../actions/user";

class SideBar extends Component {
    constructor() {
        super();
        this.state = {
            drawer: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleDisplayMap = this.handleDisplayMap.bind(this);
        this.handledrawer = this.handledrawer.bind(this);
        this.handleLogOut = this.handleLogOut.bind(this);

    }

    handleLogOut() {

        sessionStorage.removeItem('x-auth-token');
        sessionStorage.removeItem('refresh_token');

        if(localStorage.getItem("refresh_token"))
            localStorage.removeItem("refresh_token");

        this.props.userActions.logOutUser();

        this.props.history.push("/");
    }

    handleDisplayMap() {
        this.props.history.push("/map")
    }

    handleClick(href, view) {
        if (href === 'organization')
            this.props.organizationsActions.OrganizationDetails(this.props.currentOrganization);
        else
            null; // this.props.dashboardActions.changeDashboardContent({content: href, view: view});
    }

    handleSelectOrganization(organization) {
        this.props.userActions.updateOrg(organization);
        this.props.history.push("/stations");
    }


    handleAdminMenu() {

        if (this.props.user.admin)
            return (<div className="navigationListadmin">
                <ul>
                    <Link to="/admin/nodes"><NavigationComponent icon="perm_device_information" text="Admin Nodes"/></Link>
                    <Link to="/admin/stations"><NavigationComponent icon="place" text="Admin Stations"/></Link>
                    <Link to="/admin/organizations"><NavigationComponent icon="work" text="Admin Organizations"/></Link>
                </ul>
            </div>);

    }

    handleOrganizations() {
        let orgs = [];
        this.props.user.organizations.forEach((item, key) => {
            if (key < 5)
                orgs.push(<MenuItem caption={item.name} key={key}
                                    disabled={item.id === this.props.user.currentOrganization.id}
                                    onClick={this.handleSelectOrganization.bind(this, key)}/>);
            if (key === 5)
                orgs.push(<Link to={'/account'} ><MenuItem value='more' icon='more_horiz' caption='more'
                                                           key={key}/></Link>);

        });
        return orgs
    }

    displayMenu() {

        return (

            <div className="col-sm-2 col-xs-2 display-table-cell v-align box" id="navigation">
                <div className="content_sidebar">
                    <div className="naviLogo">
                        <Logo Logo={LogoSVG}/>
                    </div>
                    <div className="navigationList">
                        {this.handleAdminMenu()}
                        <ul>
                            {this.props.user.currentOrganization &&
                            <Link to="/stations"><NavigationComponent icon="home" text="My Stations"/></Link>}
                        {/*<Link to="/map" ><NavigationComponent icon="map" text="Map"/></Link>*/}
                            {this.props.user.currentOrganization &&
                            <Link to="/organization"><NavigationComponent icon="group" text={this.props.user.currentOrganization.name}/></Link>}
                        </ul>
                    </div>
                    <div className="display-table-cell box" id="navigation_bottom">
                        <IconMenu icon="help" menuRipple>
                            <MenuItem caption='Help' disabled/>
                            <MenuItem caption='Technical Information'/>
                            <MenuItem caption='FAQ'/>
                            <MenuItem caption='Troubleshooting'/>
                        </IconMenu>
                        <IconMenu icon="account_circle" menuRipple>
                            <MenuItem value='organizations' caption='Organization' disabled/>
                            {this.handleOrganizations()}
                            <MenuDivider/>
                            <MenuItem caption={this.props.user.userName} disabled/>

                            <Link to={'/account'} ><MenuItem caption='View Account'/></Link>
                            <MenuItem caption='Log Out' icon='exit_to_app' onClick={this.handleLogOut}/>
                        </IconMenu>
                    </div>
                </div>
            </div>
        );

    }

    handledrawer() {
        let drawer = this.state.drawer;

        this.setState({
            ...this.state,
            drawer: !drawer,
        });
    }

    handleMobile() {
        let md = new MobileDetect(window.navigator.userAgent);

        if (md.mobile() !== null) {
            return (
                <ThemeProvider theme={theme}>
                    <div>
                        <div id="mobilebutton">
                            <Button icon='menu' floating accent mini onClick={this.handledrawer}/>
                        </div>
                        <Drawer active={this.state.drawer} onOverlayClick={this.handledrawer}>
                            <div className="mobilemenu">
                                {this.displayMenu()}
                            </div>
                        </Drawer>
                    </div>
                </ThemeProvider>
            );
        } else {
            return (
                <ThemeProvider theme={theme}>
                    {this.displayMenu()}
                </ThemeProvider>
            );
        }
    }

    render() {
        return this.handleMobile();
    }

}

const dashboardStateToProps = (state) => {
    return {
        user: state.user,
    }
};

const dashboardDispatchToProps = (dispatch) => {
    return {
        userActions: bindActionCreators(UserActions, dispatch),
        organizationsActions: bindActionCreators(organizationsActions, dispatch)

    }
};


export default withRouter(connect(dashboardStateToProps, dashboardDispatchToProps)(SideBar))



// WEBPACK FOOTER //
// ./src/components/DashBoard/SideBar/index.js